import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import LinearProgress from '@material-ui/core/LinearProgress'
import SignIn from 'src/components/home/LoginComponent'
import credentialService, { SITE_KEY } from 'src/services/credentialService'
import useQuery from 'src/utils/hooks/useQuery'
import swal from 'sweetalert'
import { swalMessages } from '../../constants/index'
import loadScriptByURL from '../../utils/loadScriptRecapchat'

const RecoverContainer = () => {
  useEffect(() => {}, [])

  return (
    <>
      <div
        style={{
          display: 'flex',
          background: 'black',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          flexDirection: 'column',
        }}
      >
        <img
          style={{ width: '20vw', minWidth: '250px' }}
          alt=""
          src="https://storage.googleapis.com/lucia-static/media/img/auteco-logo.png"
        />
        <p style={{ color: 'white', marginLeft: '10vw', marginRight: '10vw' }}>
        Para acceder a los informes, es necesario homologar la cuenta del correo de Auteco.com. Para llevar a cabo este proceso, sigue los pasos indicados a continuación: &nbsp;
        <br/><br/>
        1. Haz clic en el siguiente  <a href="https://accounts.google.com/signup/v2/webcreateaccount?flowName=GlifWebSignIn&flowEntry=SignUp">
            enlace
          </a>, y elige la opción  "Prefiero usar mi dirección de correo electrónico actual".
          <br/>
        2. Completa los campos requeridos, ingresando el correo de Auteco.com y demás datos de la cuenta.
        <br/> <br/>
         Adicionalmente, se recomiendo visualizar el &nbsp;{' '}
          <a href="https://lucia-static.lucia.com.co/video/manual">video</a>{' '}
          &nbsp;adjunto, el cual proporciona una guía detallada sobre el proceso de homologación.
        </p>
      </div>
    </>
  )
}

export default RecoverContainer
